var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dategroup",staticClass:"date-group"},[_vm._t("default",null,{"dateGroup":true})],2)}
var staticRenderFns = []

export { render, staticRenderFns }